import { z } from 'zod'

/**
 * @deprecated use sibling DateTimeSchemaV4 instead
 */
export const DateTimeSchema = z.string().datetime({ offset: true })

/**
 * This is the canonical way to express zod date times for Omnea
 */
export const DateTimeSchemaV4 = z.iso.datetime({ offset: true })
